"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactFeather = require("react-feather");
var _ChoicesItem = _interopRequireDefault(require("./ChoicesItem"));
var _events = require("../../utils/events.js");
var _helpers = require("../../utils/helpers");
var _CustomSelectModule = _interopRequireDefault(require("../../scss/form-elements/CustomSelect.module.scss"));
var _FormModule = _interopRequireDefault(require("../../scss/form-elements/Form.module.scss"));
function CustomSelect(_ref) {
  var _inputRef$current, _inputRef$current2, _inputRef$current3;
  let {
    name,
    options,
    label = '',
    width = 100,
    multiple = false,
    placeholder = '',
    ValidIcon = _reactFeather.CheckCircle,
    InvalidIcon = _reactFeather.AlertTriangle,
    expandIconType = 'default',
    // default, chevron
    showValidation = true,
    ...attributes
  } = _ref;
  const [inputClass, setInputClass] = (0, _react.useState)("".concat(_FormModule.default['form-field__input']));
  const inputRef = (0, _react.useRef)();
  const choicesListRef = (0, _react.useRef)();
  const [validationMessage, setValidationMessage] = (0, _react.useState)('');
  const [validationStatus, setValidationStatus] = (0, _react.useState)('clean');
  const [selections, setSelections] = (0, _react.useState)([]);
  const [choices, setChoices] = (0, _react.useState)(options.map((option, index) => {
    return {
      ...option,
      id: option !== null && option !== void 0 && option.id ? option === null || option === void 0 ? void 0 : option.id : "".concat(name, "-").concat(index + 1),
      status: 'active'
    };
  }));
  const [currentSelected, setCurrentSelected] = (0, _react.useState)(null);
  const [choicesStatus, setChoicesStatus] = (0, _react.useState)('hidden'); // hidden, visible
  const currentHighlightedIndex = (0, _react.useRef)(-1);
  const widthClass = "input-width--".concat(width);

  /**
   * Sets the new status of an item in the list
   * and unsets the status of an item if there should 
   * only be one of the status type in the list
   * @param {Array} list The list to iterate over
   * @param {Number} id The id of the item to update the status of
   * @param {String} [status=selected] The status to apply
   *  
   * @returns {Array} The list of options with updated status
   */
  const setStatus = function (list, id) {
    let status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'selected';
    if (!multiple && status === 'selected' || status === 'highlighted') {
      for (const item of list) {
        if (item.status === status) {
          item.status = 'active';
          break;
        }
      }
    }
    for (const item of list) {
      if (item.id === id) {
        // add the item to the multiselect array
        if (multiple && item.status !== 'selected' && status === 'selected') setSelections([...selections, item]);
        // for single selections set the item to the new status if it's not already set to selected                    
        if (item.status !== 'selected') item.status = status;
        // if we're trying to set the status to selected, this is the item so set that
        if (status === 'selected') {
          setCurrentSelected(item);
          break;
        }
      }
    }
    return list;
  };

  /**
   * Run native broswer validation on the select input
   */
  const validate = () => {
    setTimeout(() => {
      if (inputRef.current.checkValidity()) {
        setValidationMessage('');
      } else {
        setValidationMessage(inputRef.current.validationMessage);
      }
    }, 100);
  };

  /**
   * Toggle the display of the choices list
   * when the selection section is clicked
   * @param {Object} e 
   */
  const toggleChoicesView = e => {
    e === null || e === void 0 || e.stopPropagation();
    setValidationStatus('touched');
    setInputClass("".concat(_FormModule.default['form-field__input'], " ").concat(_FormModule.default['input--touched']));
    if (choicesStatus === 'hidden') {
      setChoicesStatus('visible');
    } else {
      setChoicesStatus('hidden');
      validate();
    }
  };

  /**
   * Removes a choice from the selected list
   * @param {Number} id 
   */
  const removeSelection = id => {
    const _selections = selections;
    const newSelections = _selections.filter(selection => {
      return selection.id !== id;
    });
    setSelections([...newSelections]);
    let _choices = choices;
    const setStatus = (list, id) => {
      for (const item of list) {
        if (item.id === id) {
          item.status = 'active';
          break;
        }
        if (item.subcategories.length) setStatus(item.subcategories, id);
      }
      return list;
    };
    const newChoices = setStatus(_choices, id);
    setChoices([...newChoices]);
    document.querySelector("select[name=\"".concat(name, "\"] > option[value=\"").concat(id, "\"]")).selected = false;
  };

  /**
   * Set choice as selected when clicked
   * @param {Object} e
   * @listens SyntheticBaseEvent:onClick
   */
  const handleSelected = selectedId => {
    const _choices = structuredClone(choices);
    const newChoices = setStatus(_choices, selectedId);
    setChoices([...newChoices]);
    toggleChoicesView();
    currentHighlightedIndex.current = -1;
    const selectedChoice = choices.find(choice => choice.id === selectedId);
    // set the selected attr on the real select input
    document.querySelector("select[name=\"".concat(name, "\"] > option[value=\"").concat(selectedChoice.value, "\"]")).selected = true;
    (0, _events.publish)('scripps:customselect:selected', {
      value: selectedChoice.value
    });
  };

  /**
   * Allow keyboard navigation of choices list
   * @listens SyntheticBaseEvent:onKeyDown
   * @param {Object} e
   *   
   * @returns {Boolean} Returns false if key pressed 
   * wasn't arrow up, arrow down, or return 
   */
  const handleKeyPress = e => {
    // prevent tab from getting stuck
    if (e.key === 'Tab') return true;
    // allow arrow keys to scroll page when select is not active
    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && choicesStatus !== 'visible') return true;
    e.stopPropagation();
    e.preventDefault();
    const key = e.key;
    const _choices = choices;
    const changeHighlightedOption = index => {
      const newChoices = setStatus(_choices, choices[index].id, 'highlighted');
      setChoices([...newChoices]);
    };
    if (key === 'ArrowDown' && choicesStatus === 'visible') {
      // arrow down pressed
      if (currentHighlightedIndex.current < choices.length - 1) {
        changeHighlightedOption(currentHighlightedIndex.current + 1);
        currentHighlightedIndex.current++;
      } else {
        // if at the end go back to top of list
        changeHighlightedOption(0);
        currentHighlightedIndex.current = 0;
      }
    } else if (key === 'ArrowUp' && choicesStatus === 'visible') {
      // arrow up pressed
      if (currentHighlightedIndex.current > 0) {
        changeHighlightedOption(currentHighlightedIndex.current - 1);
        currentHighlightedIndex.current--;
      } else {
        // if at the top go down to end of list
        changeHighlightedOption(choices.length - 1);
        currentHighlightedIndex.current = choices.length - 1;
      }
    } else if (key === 'Enter') {
      // return key was pressed
      if (choicesStatus === 'visible' && currentHighlightedIndex.current !== -1) {
        const selectedId = choices[currentHighlightedIndex.current].id;
        const newChoices = setStatus(_choices, selectedId);
        setChoices([...newChoices]);
        toggleChoicesView();
        currentHighlightedIndex.current = -1;
        const selectedChoice = choices.find(choice => choice.id === selectedId);
        // set the selected attr in the real select input
        document.querySelector("select[name=\"".concat(name, "\"] > option[value=\"").concat(selectedChoice.value, "\"]")).selected = true;
        (0, _events.publish)('scripps:customselect:selected', {
          value: selectedChoice.value
        });
      } else {
        toggleChoicesView();
      }
    } else if (key === 'Escape' && choicesStatus === 'visible') {
      toggleChoicesView();
      currentHighlightedIndex.current = -1;
    } else {
      return false;
    }
    // scroll choices list so that highlighted item is in view
    if (30 * currentHighlightedIndex.current > 160) {
      choicesListRef.current.scrollTo(0, 30 * currentHighlightedIndex.current);
    } else {
      choicesListRef.current.scrollTo(0, 0);
    }
  };
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: name,
    className: (0, _helpers.classes)([_FormModule.default['form-field'], _FormModule.default[widthClass]])
  }, showValidation && /*#__PURE__*/_react.default.createElement("i", {
    className: [_FormModule.default['form-field__icon'], (_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && _inputRef$current.validity.valid ? '' : _FormModule.default['form-field__icon--invalid']].join(' '),
    style: label === '' ? {
      top: '0.4em'
    } : {}
  }, ((_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.checkValidity()) && validationStatus === 'touched' && /*#__PURE__*/_react.default.createElement(ValidIcon, null), !((_inputRef$current3 = inputRef.current) !== null && _inputRef$current3 !== void 0 && _inputRef$current3.checkValidity()) && validationStatus === 'touched' && /*#__PURE__*/_react.default.createElement(InvalidIcon, null)), label !== '' && /*#__PURE__*/_react.default.createElement("span", {
    className: _FormModule.default['form-field__label']
  }, label), /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({
    name: name,
    className: (0, _helpers.classes)([_CustomSelectModule.default['custom-select__select'], validationStatus === 'touched' && showValidation ? _CustomSelectModule.default['custom-select__select--touched'] : '']),
    multiple: multiple,
    ref: inputRef,
    tabIndex: "-1"
  }, attributes), /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }), options.length && options.map(option => {
    return /*#__PURE__*/_react.default.createElement("option", {
      value: option.value,
      selected: option.selected,
      key: "option-".concat(option.value)
    }, option.label);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([inputClass, _CustomSelectModule.default['custom-select'], 'custom-select']),
    onKeyDown: handleKeyPress,
    tabIndex: "0"
  }, multiple && /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _helpers.classes)([_CustomSelectModule.default['custom-select__selections'], 'custom-select__selections']),
    onClick: toggleChoicesView
  }, selections.length !== 0 && selections.map(selection => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _helpers.classes)([_CustomSelectModule.default['custom-select__selected'], 'custom-select__selected'])
    }, selection.label, /*#__PURE__*/_react.default.createElement("button", {
      title: "remove",
      type: "button",
      className: _CustomSelectModule.default['custom-select__remove'],
      onClick: e => {
        e.stopPropagation();
        removeSelection(selection.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_reactFeather.X, {
      width: 16,
      height: 16
    })));
  }), selections.length === 0 && placeholder !== '' && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _helpers.classes)([_CustomSelectModule.default['custom-select__placeholder'], 'custom-select__placeholder'])
  }, placeholder)), !multiple && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CustomSelectModule.default['custom-select__selection']),
    onClick: toggleChoicesView
  }, currentSelected && currentSelected.label, !currentSelected && placeholder !== '' && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _helpers.classes)([_CustomSelectModule.default['custom-select__placeholder'], 'custom-select__placeholder'])
  }, placeholder)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_CustomSelectModule.default['custom-select__choices-wrapper'], 'custom-select__choices-wrapper', choicesStatus === 'visible' ? '' : _CustomSelectModule.default['custom-select__choices-wrapper--hidden']])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_CustomSelectModule.default['custom-select__choices'], 'custom-select__choices']),
    ref: choicesListRef,
    onKeyDown: handleKeyPress
  }, /*#__PURE__*/_react.default.createElement("ul", null, choices.length !== 0 && choices.map(choice => {
    return /*#__PURE__*/_react.default.createElement(_ChoicesItem.default, {
      item: choice,
      handleOnClick: handleSelected,
      key: "choice-".concat(choice.id)
    });
  })))), expandIconType === 'default' && /*#__PURE__*/_react.default.createElement("i", {
    className: _CustomSelectModule.default['custom-select__icon']
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.Triangle, null)), expandIconType === 'chevron' && /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _helpers.classes)([_CustomSelectModule.default['custom-select__icon'], _CustomSelectModule.default['custom-select__icon--chevron'], 'custom-select__icon--chevron'])
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronDown, null))), validationMessage !== '' && showValidation && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_FormModule.default['form-field__error-message'], 'form-field__error-message'])
  }, validationMessage));
}
var _default = exports.default = CustomSelect;